import React, { useState } from 'react'
import { usePermissions } from '../../../../../../common/hooks/usePermissions'
import { TreatmentStatus } from '../../../../../../models/graphqlTypes'
import { Button } from '@mui/material'
import { CancelOutlined as CancelOutlinedIcon } from '@mui/icons-material'
import { DeleteTreatmentModal } from '../DeleteTreatmentModal'
import {
  ConfirmDialog,
  ConfirmDialogValue,
} from '../../../../../../common/components'
import { useTranslation } from '../../../../../../common/hooks/helper/useTranslation'
import { useDeleteDraftTreatment } from '../hooks/useDeleteDraftTreatment'
import { useTreatmentPanelData } from '../TreatmentPanelProvider'

export const DeleteTreatmentButton: React.FC = () => {
  const { treatment } = useTreatmentPanelData()
  const { t } = useTranslation()
  const { isOwnTreatment } = usePermissions(treatment?.doctor.id)

  const isDeleted = treatment?.status === TreatmentStatus.Cancelled
  const isDraft = treatment?.status === TreatmentStatus.Draft

  const [isDeleteTreatmentModalOpen, setDeleteTreatmentModalOpen] =
    useState(false)
  const [isDeleteDraftTreatmentModalOpen, setDeleteDraftTreatmentModalOpen] =
    useState<ConfirmDialogValue>(false)

  const [deleteDraftTreatmentMutation] = useDeleteDraftTreatment()

  return (
    <>
      {isOwnTreatment && !isDeleted && (
        <Button
          sx={{ paddingX: 2, justifyContent: 'flex-start' }}
          size="small"
          color="error"
          variant="text"
          startIcon={<CancelOutlinedIcon />}
          onClick={() =>
            isDraft
              ? setDeleteDraftTreatmentModalOpen((isOpen) => !isOpen)
              : setDeleteTreatmentModalOpen((isOpen) => !isOpen)
          }
        >
          {t(
            isDraft
              ? 'treatment:doctor.deleteDraftTreatment'
              : 'treatment:doctor.removeTreatment'
          )}
        </Button>
      )}

      {isDeleteTreatmentModalOpen && (
        <DeleteTreatmentModal
          isOpen={isDeleteTreatmentModalOpen}
          toggleIsOpen={setDeleteTreatmentModalOpen}
          treatment={treatment}
        />
      )}

      {isDeleteDraftTreatmentModalOpen && (
        <ConfirmDialog
          isAlertingDialog
          valueState={[
            isDeleteDraftTreatmentModalOpen,
            setDeleteDraftTreatmentModalOpen,
          ]}
          title={t('treatment:doctor.deleteDraftTreatment')}
          text={t('treatment:doctor.deleteEmptyTreatmentDescription')}
          onAccept={() => {
            deleteDraftTreatmentMutation({
              variables: {
                treatmentData: {
                  treatmentId: treatment.id,
                },
              },
            })
          }}
          onCancel={() => setDeleteDraftTreatmentModalOpen(false)}
        />
      )}
    </>
  )
}
